import AddressInput from "#/shared/components/AddressInput"
import { isBitcoinAddress } from "#/shared/utils"

export default function WithdrawalModalAddressInput({
  onSave,
}: {
  onSave: (value: string) => void
}) {
  return (
    <AddressInput
      placeholder="Enter BTC withdrawal address"
      onButtonClick={onSave}
      validate={(value) => isBitcoinAddress(value)}
    />
  )
}
